import './maincontent.css'
import { Link } from "react-router-dom";
import book from './images/book.png';

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import subs from './images/subs.png';
import landing from './images/landing.png';
import network from './images/network.png';
import contact from './images/contact.png';
import speaker from './images/speaker.png';
import lobby from './images/lobby.png';
import booth from './images/booth.png';
import user from './images/user.png';
import template from './images/template.png';
import cal from './images/Calculator.png';
import price from './images/Pricing.png';
import reg from './images/registration.png';
import ann from './images/announce.png'
import leader from './images/leader.png'
import order from './images/orders.png'
import mail from './images/mail.png'
import att from './images/att.png'
import ah from './images/ah.png'


function Content(){

return(


<div className=' contmax  ' >
    <div className='row expolretopicsrow'>
       
      
       <div className='col-md-6 explore '>  <p className='topics'>
          <img className='bookimage' height='60px' src={book}></img>Explore Topics</p></div>
       <div className='col-md-6'><p className='descp'>
         We did our best to cover all topics related to our product. Each section have detailed info of topic in each category.</p></div>
       
    <pre></pre>
   
  
    </div>
    <pre></pre> 



<div className='row  '>

<Link to='/help/dashboard' className='col-md cont_container m-2' style={{ textDecoration: 'none' }}>
  <div>
 
<div className='pt-1'><img src={'https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-dashboard-100-most-used-icons-flaticons-flat-flat-icons-2.png'} height='30px' width='30px'></img> <span className='contheading'>Dashboard</span> </div>

<p className='contdetails'>The dashboard is often described as the control panel of a subscription module. Subscribers log in to the dashboard and can view information and summary related to the progress and performance of their events.

</p>
</div>
</Link>

<Link to='/help/EventRegistration' className='col-md cont_container m-2' style={{ textDecoration: 'none' }}>
  <div>
<div className='pt-1'><img src={'https://img.icons8.com/external-flaticons-lineal-color-flat-icons/64/000000/external-vip-event-event-management-flaticons-lineal-color-flat-icons-2.png'} height='30px' width='30px'></img> <span className='contheading'>Event Registration</span> </div>

<p className='contdetails'>Events are the module with which an event or event can be organized. This module helps you make an event or events register for further additions.


</p>
</div>
</Link>

 


<Link to='/help/ExhibitionhallManagement' className='col-md cont_container m-2' style={{ textDecoration: 'none' }}>
  <div>
<div className='pt-1'><img src={'https://img.icons8.com/fluency/48/000000/exhibition.png'} height='30px' width='30px'></img> <span className='contheading'>Exhibition Hall Management</span> </div>

<p className='contdetails'>The exhibition is the section of the event where your products, ideas, or achievements are decoratively laid out. With the correct manifestation of your brand, exhibitions turn out to be the most efficient at raising your sales. 



</p>
</div>
</Link>

<div className='content_space m-1'></div>


<Link to='/help/LandingPageManagement' className='col-md cont_container m-2' style={{ textDecoration: 'none' }}>
<div className='pt-1'><img src={landing} height='30px' width='30px'></img> <span className='contheading'>Landing Page Management</span> </div>

<p className='contdetails'>The landing is the first page that will appear on your virtual screen when you join the event. You can customize the landing page according to your own will suiting your zest.


</p>
</Link>

<Link to='/help/NetworkManagement' className='col-md cont_container m-2' style={{ textDecoration: 'none' }}>
<div className='pt-1'><img src={network} height='30px' width='30px'></img> <span className='contheading'>Network Management</span> </div>

<p className='contdetails'>Networking enabled communication between the participants of the event. This can be done via video chat, text box, card exchange, voice chat, QnA, etc to expand your brand popularity.


</p>
</Link>




<Link  to='/help/SpeakerRoomManagement' className='col-md cont_container m-2' style={{ textDecoration: 'none' }}>
<div className='pt-1'><img src={speaker} height='30px' width='30px'></img> <span className='contheading'>Speaker Room Management
</span> </div>

<p className='contdetails'>The speakers are the participants who want to specifically speak in the event to convey themselves. Speakers have an agenda mostly related to awareness, product, information, building networking, etc.


</p>
</Link>


<div className='content_space  m-1'></div>


<Link to='/help/LobbyManagement' className='col-md cont_container m-2' style={{ textDecoration: 'none' }}>
<div className='pt-1'><img src={lobby} height='30px' width='30px'></img> <span className='contheading'>Lobby Management</span> </div>

<p className='contdetails'>The lobby is the corridor or the pathway to enter the compartments of the event like the rooms, booth, auditorium, reception, etc. You can customize your lobby choosing the things you would want to be displayed in it. 

</p>
</Link>

<Link to='/help/BoothManagement' className='col-md cont_container m-2'  style={{ textDecoration: 'none' }}>
<div className='pt-1'><img src={booth} height='30px' width='30px'></img> <span className='contheading'>Booth Management</span> </div>

<p className='contdetails'>We did our best to cover all topics related to our product. Each section have detailed info of topic in each category.

</p>
</Link>




<Link to='/help/UserManagement' className='col-md cont_container m-2' style={{ textDecoration: 'none' }}>
<div className='pt-1'><img src={user} height='30px' width='30px'></img> <span className='contheading'>User Management</span> </div>

<p className='contdetails'>We did our best to cover all topics related to our product. Each section have detailed info of topic in each category.

</p>
</Link>
<div className='content_space m-1'></div>


<Link to='/help/TemplateManagement' className='col-md cont_container m-2' style={{ textDecoration: 'none' }}>
<div className='pt-1'><img src={template} height='30px' width='30px'></img> <span className='contheading'>Template Management</span> </div>

<p className='contdetails'>In the template module, you choose the layout you wish to be added to your event. We have a set of various templates, you can choose any of them for the event you wish to host. 


</p>
</Link>

<Link to='/help/EstimateEventCost' className='col-md cont_container m-2'  style={{ textDecoration: 'none' }}>
<div className='pt-1'><img src={cal} height='24px' width='24px'></img> <span className='contheading'>Calculator</span> </div>

<p className='contdetails'>Estimate your event pricing by selecting the required no. of events and add-ons for the event.The calculator automatically finds out the costing for eac module purchased by te user depending upon the existing pricing plan.

</p>
</Link>




<Link to='/help/Pricing' className='col-md cont_container m-2' style={{ textDecoration: 'none' }}>
<div><img src={price} height='30px' width='30px'></img> <span className='contheading'>Pricing</span> </div>

<p className='contdetails'>View the event pricing for the different type of subscription plans.Each plan has a different subscirption cost.The different types of pricing falls under:
free,express ,premium and custom categories.

</p>
</Link>


<div className='content_space m-1'></div>


<Link to='/help/Subscriptionmodule' className='col-md cont_container m-2' style={{ textDecoration: 'none' }}>
<div><img src={subs} height='30px' width='30px'></img> <span className='contheading'>Login/Registration Module</span> </div>


<p className='contdetails'>The gatepass for subscription , new subscribers signup to the system while authorised subscribers login to the system and process the event proceedings.

</p>
</Link>

<Link to='/help/Registration' className='col-md cont_container m-2'  style={{ textDecoration: 'none' }}>
<div><img src={reg} height='30px' width='30px'></img> <span className='contheading'>Registration</span> </div>

<p className='contdetails'>The registration module is used for people to get themselves enrolled for the due event. The participants, audience, speakers, and organizers have to fill in the registration to join the following event. 

</p>
</Link>

<Link to='/help/Announcement' className='col-md cont_container m-2'  style={{ textDecoration: 'none' }}>
<div><img src={ann} height='30px' width='30px'></img> <span className='contheading'>Announcement</span> </div>

<p className='contdetails'>If anyone wants to make an important announcement during the session, every participant will get a pop-up message about it, this is how the attendees won't miss out on significant notifications.

</p>
</Link>
<div className='content_space m-1'></div>
<Link to='/help/Leaderboard' className='col-md cont_container m-2'  style={{ textDecoration: 'none' }}>
<div><img src={leader} height='30px' width='30px'></img> <span className='contheading'>Leaderboard</span> </div>

<p className='contdetails'>The leaderboard is a chart showing a hierarchy of attendees in an order where the most active attendees are shown at the top of the table and the least interactive is at the end of the table. 


</p>
</Link>

<Link to='/help/Reports' className='col-md cont_container m-2'  style={{ textDecoration: 'none' }}>
<div><img src='https://img.icons8.com/external-flaticons-lineal-color-flat-icons/64/000000/external-reports-productivity-flaticons-lineal-color-flat-icons.png' height='30px' width='30px'></img> <span className='contheading'>Reports</span> </div>

<p className='contdetails'>The report is an in-depth analysis of virtual information about the event. It is formulated so that the organizers get a better insight into their business and the market type with its touchpoints.


</p>
</Link>

<Link to='/help/Orders' className='col-md cont_container m-2'  style={{ textDecoration: 'none' }}>
<div><img src={order} height='30px' width='30px'></img> <span className='contheading'>Orders</span> </div>

<p className='contdetails'>With the in-built integration of e-commerce websites of the products, the attendees can make an order themselves in the event, they need not visit their website. 


</p>
</Link>
<div className='content_space m-1'></div>

<Link to='/help/Mailconfiguration' className='col-md cont_container m-2'  style={{ textDecoration: 'none' }}>
<div><img src={mail} height='30px' width='30px'></img> <span className='contheading'>Mail Configuration</span> </div>

<p className='contdetails'>We did our best to cover all topics related to our product. Each section have detailed info of topic in each category.

</p>
</Link>

<Link to='/help/Additionalattendee' className='col-md cont_container m-2'  style={{ textDecoration: 'none' }}>
<div><img src={att} height='30px' width='30px'></img> <span className='contheading'>Additional Attendee</span> </div>

<p className='contdetails'>We did our best to cover all topics related to our product. Each section have detailed info of topic in each category.

</p>
</Link>

<Link to='/help/Additionalbooths' className='col-md cont_container m-2'  style={{ textDecoration: 'none' }}>
<div><img src='https://img.icons8.com/external-xnimrodx-lineal-color-xnimrodx/64/000000/external-booth-town-xnimrodx-lineal-color-xnimrodx.png'   height='30px' width='30px'></img> <span className='contheading'>Additional Booths</span> </div>

<p className='contdetails'>The aim of the booth is to generate meaningful conversations with attendees. A variety of assets can be displayed. These include static text, logos, banners, video, and even a chat. 


</p>
</Link>
<div className='content_space m-1'></div>

<Link to='/help/Additionalhalls' className='col-md cont_container m-2'  style={{ textDecoration: 'none' }}>
<div><img src={ah}   height='30px' width='30px'></img> <span className='contheading'>Additional Halls</span> </div>

<p className='contdetails'>We did our best to cover all topics related to our product. Each section have detailed info of topic in each category.

</p>
</Link>

<div  className='col-md r m-2'  style={{ textDecoration: 'none' }}>

</div>
<div  className='col-md  m-2'  style={{ textDecoration: 'none' }}>

</div>



</div>






<br></br><br></br>
         <div class="row  ">
             <div className='col-2'></div>
           
              <div className='col-md-3 text-center'><img className='write_image' src={contact} height='100%' width='140%'></img></div>
             <div className='col-1'></div>
             <div className='col-md-4 mt-4 sidecontent'>
           <h1>Contact Us</h1>
           <p>
           If you have question which is beyond this 
             knowledgebase Kindly contact us
           </p>
           <pre></pre>  <Link to='/request' className='writebutton'> Write to us now </Link>
         

                    </div>

                    
        </div>
     




        <br></br>
     </div>


);

}

export default Content;